import { WRAPPER } from '@/shared/styles/themes';
import styled, { css } from 'styled-components';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { getThemeBrand } from '@/shared/hooks/useBrandTheme';

export const getSkeletonLoaderImageStyle = () => {
  const loader = getThemeBrand().assets.loader;

  return {
    display: 'block',
    aspectRatio: '3 / 4',
    backgroundImage: `url(${loader.default})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };
};

export const Wrapper = styled.div<{ $hasScroll?: boolean }>`
  ${WRAPPER};

  display: block;
  flex-direction: column;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    //padding: 0 18px;

    ${brandIsPh &&
    css`
      margin-top: 12px;
    `}
  }

  ${({ $hasScroll }) =>
    $hasScroll &&
    css`
      @media (max-width: 768px) {
        margin: 0px;

        ${brandIsPh &&
        css`
          margin-top: 12px;
        `}
      }
    `}
`;

export const HomeGamesWrapper = Wrapper;

export const NotFound = styled.div`
  text-align: center;
  display: inline-block;
  margin: 60px;
`;

export const Providers = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    display: flex;
    gap: 14px;
    scroll-behavior: smooth;
    margin: 6px 18px;

    ${brandIsPh &&
    css`
      margin: 6px 12px;
    `}
  }
`;

export const ProvidersWrapper = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: flex;
    scroll-behavior: smooth;
    overflow: scroll;
    flex-direction: column;
    margin-bottom: 0px;
    align-items: flex-start;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Provider = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #27262b;
  position: relative;
  padding: 0px 6px;
  width: 100%;
  min-height: 129px;
  cursor: pointer;
  @media (max-width: 768px) {
    min-width: 127px;
    min-height: 86px;
    width: 127px;
    height: 86px;
  }
`;

export const ProviderGamesCount = styled.div`
  position: absolute;
  color: #afafee;
  opacity: 0.5;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 23.4px */
  top: 8px;
  right: 8px;
`;

export const PopularGamesWrapper = styled.div`
  min-height: 80px;
  @media (max-width: 768px) {
    min-height: 60px;
  }
`;

export const RecordWinWrapper = styled.div<{ $collapse?: boolean }>`
  min-height: ${({ $collapse }) => ($collapse ? '0' : '424px')};
  @media (max-width: 768px) {
    min-height: ${({ $collapse }) => ($collapse ? '0' : '416px')};
  }
`;
export const JpWrapper = styled.div`
  padding-top: 18px;
  min-height: 245px;
  @media (max-width: 768px) {
    min-height: 343px;
  }
`;
export const ScrollTrigger = styled.div`
  height: 1px;
`;
